import { Controller } from "stimulus";

function titleFile() {
  return `Listado de ${document.getElementsByTagName("h1")[0].innerHTML}`;
}
export default class extends Controller {
  connect() {
    console.log("Probando datatables");
    this.initilizeTable();
    document
      .querySelector(".dt-buttons")
      .insertAdjacentHTML(
        "beforebegin",
        '<small class="" style="color:#348bd6"><em>Descargar</e></small>'
      );
  }

  initilizeTable() {
    // let option = $("#audit-view");
    // let orderOption = "";
    // if (option.val() != "") {
    // orderOption = "des";
    // } else {
    // orderOption = "des";
    // }

    var table = $("#trd-list").DataTable({
      order: [],
      // rowReorder: {
      // selector: "td:nth-child(1)",
      // },
      responsive: true,
      dom: "Bfrtipl",
      buttons: [
        {
          extend: "pdf",
          text: '<i class="bi bi-filetype-pdf"></i>',
          titleAttr: "Exportar PDF",
          title: titleFile(),
        },
        {
          extend: "csv",
          text: '<i class="bi bi-filetype-csv"></i>',
          titleAttr: "Exportar csv",
          title: titleFile(),
        },
        {
          extend: "excel",
          text: '<i class="bi bi-filetype-xlsx"></i>',
          titleAttr: "Exportar xlsx",
          title: titleFile(),
        },
      ],
      language: {
        autoFill: {
          cancel: "Cancelar",
          fill: "Llenar las celdas con <i>%d<i></i></i>",
          fillHorizontal: "Llenar las celdas horizontalmente",
          fillVertical: "Llenar las celdas verticalmente",
        },
        decimal: ",",
        emptyTable: "No hay datos disponibles en la Tabla",
        infoFiltered: "Filtrado de _MAX_ entradas totales",
        infoThousands: ".",
        lengthMenu: "Mostrar _MENU_ entradas",
        loadingRecords: "Cargando...",
        paginate: {
          first: "Primera",
          last: "Ultima",
          next: "Siguiente",
          previous: "Anterior",
        },
        processing: "Procesando...",
        search: "Búsqueda:",
        searchBuilder: {
          add: "Agregar condición",
          button: {
            0: "Constructor de búsqueda",
            _: "Constructor de búsqueda (%d)",
          },
          clearAll: "Quitar todo",
          condition: "Condición",
          conditions: {
            date: {
              after: "Luego",
              before: "Luego",
              between: "Entre",
              empty: "Vacio",
              equals: "Igual",
            },
          },
          data: "Datos",
          deleteTitle: "Borrar regla de filtrado",
          leftTitle: "Criterio de alargado",
          logicAnd: "Y",
          logicOr: "O",
          rightTitle: "Criterio de endentado",
          title: {
            0: "Constructor de búsqueda",
            _: "Constructor de búsqueda (%d)",
          },
          value: "Valor",
        },
        thousands: ".",
        zeroRecords:
          "No se encontraron registros que coincidan con la búsqueda",
        datetime: {
          previous: "Anterior",
          next: "Siguiente",
          hours: "Hora",
          minutes: "Minuto",
          seconds: "Segundo",
          amPm: ["AM", "PM"],
          months: {
            0: "Enero",
            1: "Febrero",
            10: "Noviembre",
            11: "Diciembre",
            2: "Marzo",
            3: "Abril",
            4: "Mayo",
            5: "Junio",
            6: "Julio",
            7: "Agosto",
            8: "Septiembre",
            9: "Octubre",
          },
          unknown: "-",
          weekdays: ["Dom", "Lun", "Mar", "Mie", "Jue", "Vie", "Sab"],
        },
        editor: {
          close: "Cerrar",
          create: {
            button: "Nuevo",
            title: "Crear nueva entrada",
            submit: "Crear",
          },
          edit: {
            button: "Editar",
            title: "Editar entrada",
            submit: "Actualizar",
          },
          remove: {
            button: "Borrar",
            title: "Borrar",
            submit: "Borrar",
            confirm: {
              _: "Está seguro que desea borrar %d filas?",
              1: "Está seguro que desea borrar 1 fila?",
            },
          },
          multi: {
            title: "Múltiples valores",
            info: "La selección contiene diferentes valores para esta entrada. Para editarla y establecer todos los items al mismo valor, clickear o tocar aquí, de otra manera conservarán sus valores individuales.",
            restore: "Deshacer cambios",
            noMulti:
              "Esta entrada se puede editar individualmente, pero no como parte de un grupo.",
          },
          error: {
            system:
              'Ocurrió un error de sistema (&lt;a target="\\" rel="nofollow" href="\\"&gt;Más información).',
          },
        },
        aria: {
          sortAscending: ": orden ascendente",
          sortDescending: ": orden descendente",
        },
        info: "Mostrando _START_ a _END_ de _TOTAL_ entradas",
        infoEmpty: "Mostrando 0 a 0 de 0 entradas",
      },
    });

    $(".dt-button").addClass("btn btn-outline-primary");
  }
}
